import { useState, useCallback, memo } from "react";
import { RefreshCw } from "lucide-react";
import { getSuggestions } from "@/lib/suggestion-pool";

interface SuggestionChipsProps {
  onSelect: (text: string) => void;
}

export const SuggestionChips = memo(function SuggestionChips({
  onSelect,
}: SuggestionChipsProps) {
  const [chips, setChips] = useState(() => getSuggestions(8));

  const refresh = useCallback(() => {
    setChips(getSuggestions(8));
  }, []);

  return (
    <div className="flex flex-wrap items-center gap-2">
      {chips.map((chip) => (
        <button
          key={chip}
          onClick={() => onSelect(chip)}
          className="px-3 py-1.5 rounded-full text-xs bg-white/5 border border-white/10 text-muted-foreground hover:text-foreground hover:bg-white/10 hover:border-white/20 transition-all"
        >
          {chip}
        </button>
      ))}
      <button
        onClick={refresh}
        className="h-7 w-7 flex items-center justify-center rounded-full hover:bg-white/10 text-muted-foreground hover:text-foreground transition-all"
        title="Refresh suggestions"
      >
        <RefreshCw className="w-3.5 h-3.5" />
      </button>
    </div>
  );
});
